import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Mode } from '../models/commonEnums';
import { Store } from '../reducers';
import styles from './PrimaryButton.module.scss';
import spinner from './Spinner';

type Props = {
    title?: string;
    type?: 'button' | 'submit';
    onClick: (e: SyntheticEvent<HTMLButtonElement>) => void | Promise<void>;
    id?: string;
    loading?: boolean;
    testAttr?: string;
};

const PrimaryButton = ({ type, title, onClick, id, loading, testAttr }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    const { mode } = useSelector((state: Store) => state.user);
    let buttonStyle = styles.button;
    if (mode === Mode.b2c_mobile) buttonStyle = styles.b2cMobile;
    return (
        <button
            type={type || 'button'}
            id={id}
            className={buttonStyle}
            onClick={(e): void => {
                if (!loading) onClick(e);
            }}
            {...{ [`data-${testAttr || 'button'}`]: true }}
        >
            {loading && spinner}
            {!loading && title && txt(title)}
        </button>
    );
};

export default PrimaryButton;
